import { Link } from 'react-router-dom';
import { FileText, Users, Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useSearch, useUsers } from '@/lib/queries';

export function AdminDashboardPage() {
  const articles = useSearch({ page: 1, sort: 'date_desc' });
  const users = useUsers();

  return (
    <div className="container-wide py-8">
      <h1 className="font-serif text-2xl font-semibold mb-6">Pannello amministratore</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0">
            <CardTitle className="text-sm font-medium">Articoli</CardTitle>
            <FileText className="h-4 w-4 text-(--color-muted-foreground)" />
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-2xl font-semibold tabular-nums">
              {articles.data?.total.toLocaleString('it-IT') ?? '—'}
            </p>
            <div className="flex flex-col gap-2">
              <Button asChild variant="outline" size="sm">
                <Link to="/admin/articoli">Gestisci</Link>
              </Button>
              <Button asChild size="sm">
                <Link to="/admin/articoli/nuovo">
                  <Plus className="h-4 w-4" /> Nuovo articolo
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0">
            <CardTitle className="text-sm font-medium">Utenti</CardTitle>
            <Users className="h-4 w-4 text-(--color-muted-foreground)" />
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-2xl font-semibold tabular-nums">{users.data?.users.length ?? '—'}</p>
            <div className="flex flex-col gap-2">
              <Button asChild variant="outline" size="sm">
                <Link to="/admin/utenti">Gestisci</Link>
              </Button>
              <Button asChild size="sm">
                <Link to="/admin/utenti/nuovo">
                  <Plus className="h-4 w-4" /> Nuovo utente
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
